import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import IconPlus from '../../../assets/images/icons/plus_w.png';
import { Note, Page } from '../../../helbest';
import { API } from '../../../request/api';
import { ReactComponent as EmptyBoxIcon } from './../../../assets/svg/empty-box.svg';
import styles from './Address.module.css';
import Dataform from './Dataform/Dataform';

const Addresses = ({ Login, history, match }) => {
  const [lat, set_lat] = useState(35.6892);
  const [lng, set_lng] = useState(51.389);
  const [addr, set_addr] = useState('');
  const [region, set_region] = useState('');
  const [addr_list, set_addr_list] = useState([]);
  const [region_list, set_region_list] = useState([]);
  const [show_new_addr, set_show_new_addr] = useState(false);
  const [address_editable, set_address_editable] = useState('');
  const [modal_visible, set_modal_visible] = useState(false);
  const [address_to_delete, set_address_to_delete] = useState(0);
  const [zip_code, set_zip_code] = useState('');
  const [loading, set_loading] = useState(true);

  const new_addr = (new_address) => {
    if (new_address === 'new') {
      set_show_new_addr(!show_new_addr);
      set_address_editable('');
    }

    API.get
      .regions(Login.city_id)
      .then((response) => {
        if (response.success) {
          set_region_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        console.error('Error : ', error);
      });
  };

  const set = (id, region2) => {
    set_region(region2);
  };

  const get = () => {
    set_loading(true);
    API.get
      .userAddresses(Login.city_id)
      .then((response) => {
        set_loading(false);
        if (response.success) {
          set_addr_list(response.data);
        }
        return response;
      })
      .catch((error) => {
        set_loading(false);
        console.error('Error : ', error);
      });
  };

  // api calls
  const set_address = () => {
    API.post
      .userAddresses(region, addr, lat, lng, zip_code)
      .then((response) => {
        if (response.success) {
          get();
          set_show_new_addr(false);
          set_addr('');
          if (match.params.route === 'a') {
            history.push('/delivery/');
          }
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  const delete_address = () => {
    set_modal_visible(false);
    API.del
      .userAddresses(address_to_delete)
      .then((response) => {
        if (response.success) {
          get();
          set_show_new_addr(false);
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  const edit_address = (address_id) => {
    API.put
      .userAddresses(region, addr, lat, lng, zip_code, address_id)
      .then((response) => {
        if (response.success) {
          get();
          set_show_new_addr(false);
          set_addr('');
          set_address_editable('');
        } else {
          Note.error(response.message);
        }
        return response;
      })
      .catch((error) => {
        Note.error('خطا در اتصال به سرور');
        console.error('Error : ', error);
      });
  };

  // should handle later
  useEffect(() => {
    // user_location();
    get();
    if (match.params.route === 'a') {
      new_addr('new');
    }
  }, []); // eslint-disable-line

  let back_address = null;
  switch (match.params.route) {
    case 'p':
      back_address = '/profile/';
      break;
    case 'd':
      back_address = '/delivery/';
      break;
    default:
      back_address = '/profile/';
      break;
  }

  return (
    <Page
      address={back_address}
      back={true}
      className={`${styles.PageAddress} page-address`}
      footer={match.params.route === 'd' || match.params.route === 's' ? <div /> : null}
      header_back_title={
        match.params.route === 'd' || match.params.route === 's' ? `بازگشت به سبد` : ''
      }
      headerFix
      logo
      mobileContainer
      no_header_center_label={match.params.route === 'd' || match.params.route === 's'}
      showFooter
      title="آدرس ها">
      <div
        className={`${styles.DeliveryItemModalContent} ${!!addr_list && addr_list.length === 0 && !loading && !show_new_addr ? styles.CenterBase : ''}`}>
        {!!addr_list && addr_list.length === 0 && !loading && !show_new_addr ? (
          <div className={styles.EmptyContainer}>
            <EmptyBoxIcon className={styles.EmptyBoxIcon} />
            <div className={styles.EmptyText}>آدرسی وجود ندارد</div>
          </div>
        ) : null}
        {addr_list.map((item, index) => (
          <label
            key={index}
            className="radio-input no-mr radio-ml adresses-container "
            style={{
              paddingRight: '8px',
              paddingLeft: '8px',
              paddingBottom: '18px',
              marginLeft: 0,
              marginRight: 0
            }}>
            <input
              name="ma"
              onChange={(e) => set(e.target.value, item.region_id)}
              type="radio"
              value={item.id}
            />

            {address_editable !== item.id ? (
              <div className="addresses-data-container mar-b-10">
                <p>
                  {item.region} - {item.address}
                </p>
              </div>
            ) : null}

            {address_editable === item.id ? (
              <Dataform
                addr={addr}
                edit_address={edit_address}
                item={item}
                lat={lat}
                lng={lng}
                new_addr={new_addr}
                region={region}
                region_list={region_list}
                set_addr={set_addr}
                set_address={set_address}
                set_address_editable={set_address_editable}
                set_lat={set_lat}
                set_lng={set_lng}
                set_region={set_region}
                set_zip_code={set_zip_code}
                zip_code={zip_code}
              />
            ) : null}

            {address_editable !== item.id ? (
              <div className="addresses-button-container">
                <button
                  onClick={() => {
                    set_modal_visible(true);
                    set_address_to_delete(item.id);
                    set_show_new_addr(false);
                    set_region('');
                    set_addr('');
                    set_zip_code('');
                  }}
                  type="button">
                  حذف
                </button>

                <button
                  onClick={() => {
                    set_address_editable(item.id);
                    set_lat(item.latitude);
                    set_lng(item.longitude);
                    set_addr(item.address);
                    set_zip_code(item.zip_code);
                    set_region(item.region_id);
                    set_show_new_addr(false);
                    new_addr();
                  }}
                  type="button">
                  اصلاح
                </button>
              </div>
            ) : null}
          </label>
        ))}

        <Modal
          centered={true}
          className="address-delete-modal"
          closable={false}
          footer={false}
          visible={modal_visible}>
          <div className="flex column text-center">
            <label className="text-center">آیا می خواهید این آدرس را حذف نمایید؟</label>
            <div className="buttons">
              <button onClick={() => delete_address()} type="button">
                بله
              </button>
              <button
                onClick={() => {
                  set_modal_visible(false);
                  set_address_to_delete(0);
                }}
                type="button">
                خیر
              </button>
            </div>
          </div>
        </Modal>

        {!show_new_addr ? (
          <div className="text-center add-new-addr">
            <button
              className="btn add-new-address-button"
              onClick={() => {
                set_region('');
                set_addr('');
                set_zip_code('');
                new_addr('new');
              }}
              type="button">
              <img alt="+" className="hei-15 mar-l-10" src={IconPlus} />
              افزودن آدرس جدید
            </button>
          </div>
        ) : null}
        {show_new_addr ? (
          <div className="adresses-container new-address-form">
            <Dataform
              addr={addr}
              edit_address={edit_address}
              item={null}
              lat={lat}
              lng={lng}
              new_addr={new_addr}
              region={region}
              region_list={region_list}
              set_addr={set_addr}
              set_address={set_address}
              set_address_editable={set_address_editable}
              set_lat={set_lat}
              set_lng={set_lng}
              set_region={set_region}
              set_zip_code={set_zip_code}
              zip_code={zip_code}
            />
          </div>
        ) : null}
      </div>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  Login: state.Login
});

export default connect(mapStateToProps)(Addresses);
